import axios from 'axios';

const identificationsApi = {
	identify: (value) => {
		return axios
			.get(
				`https://api.evrythng.io/v2/scan/identifications?filter=${encodeURIComponent(
					`type=qr_code&value=${value}`
				)}`,
				{
					headers: {
						Authorization: window.evrythngToken.apiKey,
					},
				}
			)
			.then(({ data }) => data);
	},
	identifyDigimarc: (image) => {
		return axios
			.post(
				`https://api.evrythng.io/v2/scan/identifications?filter=${encodeURIComponent(
					`type=qr_code&value=digimarc&type=gs1:21`
				)}`,
				{ image },
				{
					headers: {
						Authorization: window.evrythngToken.apiKey,
					},
				}
			)
			.then(({ data }) => data);
	},
};

export default identificationsApi;
